import { ImpactInventory } from 'features/patient/assessment/questionnaires/impact/impactAPISlice';
import { Inventory } from 'lib/documents';
import moment from 'moment';

/**
 * Transforms an impact test to inventory
 * @param impactTest A test from ImPACT
 * @returns An Inventory object that stores the results of the ImPACT test
 */
export function transformImpactTestToInventory(
  impactTest: ImpactInventory
): Inventory {
  /**
   * Extract the values that are relevant
   *
   * The ImPACT API specifies these values can be undefined.
   * This is not expected to happen but to be safe a default value is set
   */
  const {
    userMemoryCompositeScoreVerbal = 0,
    userImpulseControlCompositeScore = 0,
    userMemoryCompositeScoreVisual = 0,
    userReactionTimeCompositeScore = 0,
    userVisualMotorCompositeScore = 0
  } = impactTest.data;

  return {
    id: impactTest.id,
    date: moment(impactTest.date),
    data: {
      userMemoryCompositeScoreVerbal,
      userImpulseControlCompositeScore,
      userMemoryCompositeScoreVisual,
      userReactionTimeCompositeScore,
      userVisualMotorCompositeScore
    }
  };
}
